import { Configuration, PopupRequest, LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    authority: "https://login.microsoftonline.com/organizations", 
    clientId: "e0c45db7-96a1-4d91-810d-94f9eaffed43",
    redirectUri: "https://passport.azdev.kcnsc.doe.gov/.auth/login/aad/callback",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(`MSAL ERROR: ${message}`);
            return;
          case LogLevel.Warning:
            console.warn(`MSAL WARNING: ${message}`);
            return;
          case LogLevel.Info:
            console.info(`MSAL INFO: ${message}`);
            return;
          case LogLevel.Verbose:
            console.debug(`MSAL VERBOSE: ${message}`);
            return;
        }
      },
      logLevel: LogLevel.Warning, 
      piiLoggingEnabled: false
    }
  }
};

// User scopes to request
export const loginRequest: PopupRequest = {
  scopes: ["User.Read", "Sites.Read.All"] 
};

// Additional scopes to request
export const sharePointScopeRequest: PopupRequest = {
  scopes: ["Sites.Read.All", "Sites.ReadWrite.All"]
};